<template>
  <div class="pageDiv">
    <v-card class="no-login" v-if="!$AuthSvc.isLogin() || !$AuthSvc.isAdmin()">
      <v-card-title style="padding-bottom:0">
        <span class="page-title">Register Admin</span>
      </v-card-title>

      Must login as ADMIN to view data
    </v-card>

    <v-card class="main-card" v-if="$AuthSvc.isLogin() && $AuthSvc.isAdmin()">
      <v-card-text>
        <input class="checkbox" type="checkbox" v-model="showFW" style="margin-right: 10px" @change="updateList()">
        <span class="label16">FW Crew</span>
      </v-card-text>

      <v-card-text class="main-card" v-if="$AuthSvc.isLogin()">
        <v-card-title style="padding-bottom:0">
          <span class="page-title">Register Players Admin ({{memberPlayers.length}})</span>
        </v-card-title>

        <v-card-text class="card">
          <div class="courseList">
            <span class="label18">Tournaments:</span>
            <ul>
              <li v-for="(tn, index) in registerTournaments" :key="tn">
                <input class="checkbox" type="radio" name="selectedTn" @click="loadRegisteredPlayers(tn.tournament)">
                <span>
                {{tn.course.name}}
              </span>
              </li>
            </ul>
          </div>

          <div class="nameList">
            <span class="label18">Registered Players:</span>
            <ul>
              <li v-for="(player, index) in registerPlayers" :key="player">
                <span>
                {{index+1}}. {{player.firstName}} {{player.middleName}} {{player.lastName}}
              </span>
              </li>
            </ul>
          </div>


          <div class="nameList">
            <span class="label18">Select name to register:</span>
            <ul>
              <li v-for="(memberPlayer, index) in displayPlayers" :key="memberPlayer.playerId">
                <input class="checkbox" type="checkbox" v-model="memberPlayer.selected">
                <span>
                {{index+1}}. {{memberPlayer.player.firstName}} {{memberPlayer.player.middleName}} {{memberPlayer.player.lastName}}
              </span>
              </li>
            </ul>
          </div>
        </v-card-text>

        <v-card-text>
          <div style="display:inline-block;width:100%;">
            <v-btn class="add-button" @click="submit()">Save</v-btn>
          </div>
        </v-card-text>
      </v-card-text>
    </v-card>

  </div>
</template>

<script>
import swal from 'sweetalert';

  export default {
    name: "login",
    data: () => ({
      memberPlayers: [],
      displayPlayers: [],
      registerPlayers: [],
      registerPlayerIds: [],
      registerTournaments: [],
      selectedTournament: null,
      showFW: false,
      selectedTn: null
    }),
    mounted: function() {
      this.$AuthSvc.authenticated(this.load);      
    },
    methods: {
      load() {
        this.loadTournaments();
        this.loadPlayers();
      },
      loadTournaments() {
        var _this = this;

        _this.$CommandSvc.get(_this, '/public/tournaments/status/REGISTRATION_LIST', function(data) {
          _this.registerTournaments = data;
          for(var i=0; i < _this.registerTournaments.length; i++) {
            _this.registerTournaments[i].selected = false;
          }
        });
      },
      loadPlayers() {
        var _this = this;

        this.axios.get('/admin/players')
        .then(function (response) {
            _this.memberPlayers = [];
            for(var i=0; i < response.data.length; i++) {
              if (!response.data[i].player.firstName.startsWith('Guest') &&
                  !response.data[i].player.firstName.startsWith('Vegas')) {
                 response.data[i].selected = false;
                 _this.memberPlayers.push(response.data[i]);
              }
            }
            _this.displayPlayers = _this.memberPlayers;
        })
        .catch(function (error) {
            console.log('ERROR: ' + error);
        });
      },
      loadRegisteredPlayers(tournament) {
        var _this = this;

        this.selectedTournament = tournament;
        let uri = '/api/tournaments/'+tournament.tournamentId+'/registrations-admin';
        _this.$CommandSvc.get(_this, uri, function(data) {
          _this.registerPlayers = data;
          _this.registerPlayerIds = new Array();
          for(var i=0; i < data.length; i++) {
            _this.registerPlayerIds.push(data[i].playerId);
          }

          _this.updateList();
        });
      },
      updateList() {
        var _this = this;

        _this.displayPlayers = new Array();
        for(var i=0; i < _this.memberPlayers.length; i++) {
          if (_this.showFW) {
            if (_this.memberPlayers[i].player.isFw === 'Y') {
              _this.memberPlayers[i].selected = false;
              if (! _this.registerPlayerIds.includes(_this.memberPlayers[i].player.playerId)) {
                _this.displayPlayers.push(_this.memberPlayers[i]);
              }
            }
          }
          else {
            _this.memberPlayers[i].selected = false;
            _this.displayPlayers.push(_this.memberPlayers[i]);
          }
        }
      },
      submit() {
        var _this = this;
        for(var j=0; j < _this.displayPlayers.length; j++) {
          if (_this.displayPlayers[j].selected) {
            _this.save(_this.selectedTournament.tournamentId, _this.displayPlayers[j].player);
          }
        }

        _this.updateList();
      },
      save(tournamentId, player) {
          var _this = this;

          var scoreCard = {
            playerId: player.playerId,
            tournamentId: tournamentId,
            flight: player.defaultFlight,
            isOfficial: false,
            isRegister: true,
            fee: _this.selectedTournament.memberFee,
            lateFee: 0,
            raffle: 0,
            memberFee: 0,
            holeInOne: 0,
            birdieHunt: 'No',
            owe: _this.selectedTournament.memberFee,
            paymentType: "Zelle",
            specialRequest: ""
          };

          this.axios.post('/api/tournaments/registration', scoreCard)
          .then(function (response) {
              var scoreCard = response.data;
              for(var i=0; i < _this.displayPlayers.length; i++) {
                if (_this.displayPlayers[i].player.playerId === scoreCard.playerId) {
                  _this.displayPlayers[i].selected = false;
                }
              }

              swal({
                  title: "Success!",
                  text: "Register completed.",
                  type: "success"
              }).then(function() {
                  window.location.reload();
              });
          })
          .catch(function (error) {
              swal("Error", "Registration failed. " + player.nickName, "error");
              console.log('ERROR: ' + error);
          });
      }
    }
  }

</script>

<style scoped>
  .card {
    display: inline-block;
    width: 100%;
    margin-bottom: 10px;
  }

  .nameList, .courseList {
    display: inline-block;
    float: left;
    margin-right: 12px;
    height: 600px;
    width: 100%;
    border: 1px solid black;
    padding: 10px;
    overflow-y: scroll;
    margin-bottom: 7px;
  }

  .courseList {
    height: 100px;
  }

  select {
    margin-right: 10px;
  }

  .checkbox {
    height: 20px;
    width: 20px;
  }


  @media (min-width: 768px) {
    .nameList, .courseList {
      height: 600px;
      width: 300px;
    }
  }

</style>